<template>
  <div class="card shadow-sm rounded-4 p-3 mb-4 border-0 resume-cv">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="fw-bold mb-0 text-danger"><i class="bi bi-heart-pulse me-1"></i>Constantes</h6>
      <button v-if="peutSaisir" class="btn btn-sm btn-outline-danger" @click="saisie = true"><i class="bi bi-plus"></i> Prendre</button>
    </div>
    <div v-if="!derniere" class="small text-muted">Pas encore de constantes pour ce patient.</div>
    <template v-else>
      <div class="d-flex flex-wrap gap-3 small">
        <span v-if="derniere.tensionSystolique"><strong>TA</strong> {{ derniere.tensionSystolique }}/{{ derniere.tensionDiastolique ?? '?' }}</span>
        <span v-if="derniere.pouls"><strong>Pouls</strong> {{ derniere.pouls }}</span>
        <span v-if="derniere.temperature != null"><strong>T°</strong> {{ String(derniere.temperature).replace('.', ',') }} °C</span>
        <span v-if="derniere.saturation != null"><strong>SpO₂</strong> {{ derniere.saturation }} %</span>
        <span v-if="derniere.frequenceRespiratoire"><strong>FR</strong> {{ derniere.frequenceRespiratoire }}</span>
        <span v-if="derniere.poids != null"><strong>Poids</strong> {{ decimal(derniere.poids) }} kg</span>
        <span v-if="derniere.imc"><strong>IMC</strong> {{ decimal(derniere.imc) }}</span>
        <span v-if="derniere.glycemie != null"><strong>Glycémie</strong> {{ String(derniere.glycemie).replace('.', ',') }} g/L</span>
        <span v-if="derniere.douleur != null"><strong>Douleur</strong> {{ derniere.douleur }}/10</span>
      </div>
      <div class="mt-1">
        <span v-for="a in derniere.alertes" :key="a" class="badge bg-danger me-1">{{ a }}</span>
        <small class="text-muted">{{ dateHeureFr(derniere.prisLe) }}<span v-if="derniere.prisPar"> — {{ derniere.prisPar }}</span><span v-if="derniere.consultationId && derniere.consultationId !== Number(consultationId)"> (consultation précédente)</span></small>
      </div>
    </template>
    <constantes-modal :visible="saisie" titre="ce patient" :cible="consultationId ? { consultation: Number(consultationId) } : { patient: Number(patientId) }" @fermer="saisie = false" @enregistre="charger" />
  </div>
</template>

<script>
import api from '@/api'
import ConstantesModal from '@/components/accueil/ConstantesModal.vue'
import { decimal, dateHeureFr } from '@/utils/libelles'

export default {
  name: 'ResumeConstantes',
  components: { ConstantesModal },
  props: { patientId: { type: [Number, String], default: null }, consultationId: { type: [Number, String], default: null } },
  data() {
    return { liste: [], saisie: false }
  },
  computed: {
    derniere() {
      return this.liste[0] || null
    },
    peutSaisir() {
      return this.$store.getters.hasAnyPermission(['CONSTANTES_SAISIR', 'CONSULT_TRAITER'])
    }
  },
  watch: {
    patientId: { immediate: true, handler() { this.charger() } }
  },
  methods: {
    decimal,
    dateHeureFr,
    async charger() {
      if (!this.patientId) return
      try {
        this.liste = (await api.custom(`patients/${this.patientId}/constantes`, 'GET')).data.data
      } catch (e) {
        this.liste = []
      }
    }
  }
}
</script>

<style scoped>
.resume-cv { background: #fff7f7; }
</style>
